export const SwinkelsFamilyBreweryMixin = (Base) =>
  class extends Base {
    connectSwinkelsFamilyBrewery() {
      this._onEditorDataChangeUpdateSwinkelsFamilyBrewery = this.updateSwinkelsFamilyBrewery.bind(this)
      this._onScrollUpdateSwinkelsFamilyBreweryEditorPosition = this.updateSwinkelsFamilyBreweryEditorPosition.bind(this)

      const editorDataInput = document.getElementById("product_personalization_editor_data")
      if (editorDataInput) {
        editorDataInput.addEventListener('change', this._onEditorDataChangeUpdateSwinkelsFamilyBrewery)
      }

      this.initSwinkelsFamilyBreweryEditor();
    }

    initSwinkelsFamilyBreweryEditor() {
      this.swinkelsFamilyBreweryEditor = document.getElementById('swinkels_family_brewery_editor');

      if (this.swinkelsFamilyBreweryEditor) {
        this.swinkelsFamilyBreweryEditor.style.position = 'absolute';
        this.swinkelsFamilyBreweryEditor.style.zIndex = '1000';
        this.swinkelsFamilyBreweryEditor.style.overflow = 'auto';
        this.swinkelsFamilyBreweryEditor.style.backgroundColor = '#ffffff';
        this.swinkelsFamilyBreweryEditor.style.padding = '1rem';

        this.hideEditSwinkelsFamilyBreweryEditor();

        window.addEventListener('scroll', this._onScrollUpdateSwinkelsFamilyBreweryEditorPosition);
        window.addEventListener('resize', this._onScrollUpdateSwinkelsFamilyBreweryEditorPosition);
      }
    }

    disconnectSwinkelsFamilyBrewery() {
      const editorDataInput = document.getElementById("product_personalization_editor_data")
      if (editorDataInput && this._onEditorDataChangeUpdateSwinkelsFamilyBrewery) {
        editorDataInput.removeEventListener('change', this._onEditorDataChangeUpdateSwinkelsFamilyBrewery)
      }

      if (this._onScrollUpdateSwinkelsFamilyBreweryEditorPosition) {
        window.removeEventListener('scroll', this._onScrollUpdateSwinkelsFamilyBreweryEditorPosition);
        window.removeEventListener('resize', this._onScrollUpdateSwinkelsFamilyBreweryEditorPosition);
      }
    }

    editSwinkelsFamilyBrewery() {
      if (!this.swinkelsFamilyBreweryEditor) {
        this.initSwinkelsFamilyBreweryEditor();
      }

      this.updateSwinkelsFamilyBreweryEditorPosition();
      this.swinkelsFamilyBreweryEditor.style.visibility = '';

      const printess = document.querySelector('printess-component');
      const nextButtonBar = printess.shadowRoot.querySelector('.bc-panel-basket-simple');
      if (nextButtonBar) {
        nextButtonBar.style.display = 'none';
      }
    }

    hideEditSwinkelsFamilyBreweryEditor() {
      this.swinkelsFamilyBreweryEditor.style.visibility = 'hidden';

      if (!this.editorReady) { return; }
      const printess = document.querySelector('printess-component');
      const nextButtonBar = printess.shadowRoot.querySelector('.bc-panel-basket-simple');
      if (nextButtonBar) {
        nextButtonBar.style.display = '';
      }
    }

    updateSwinkelsFamilyBreweryEditorPosition() {
      const printess = document.querySelector('printess-component');
      if (!printess || !this.swinkelsFamilyBreweryEditor) return;

      const propertiesPanel = printess.shadowRoot.querySelector('bc-panel-properties');
      const pagesPanel = printess.shadowRoot.querySelector('bc-panel-pages-default');

      const rects = [];
      if (propertiesPanel) rects.push(propertiesPanel.getBoundingClientRect());
      if (pagesPanel) rects.push(pagesPanel.getBoundingClientRect());

      const minTop = Math.min(...rects.map(r => r.top));
      const minLeft = Math.min(...rects.map(r => r.left));
      const maxRight = Math.max(...rects.map(r => r.right));
      const maxBottom = Math.max(...rects.map(r => r.bottom));

      const width = maxRight - minLeft;
      const height = maxBottom - minTop;

      this.swinkelsFamilyBreweryEditor.style.top = `${window.scrollY + minTop}px`;
      this.swinkelsFamilyBreweryEditor.style.left = `${window.scrollX + minLeft}px`;
      this.swinkelsFamilyBreweryEditor.style.width = `${width}px`;
      this.swinkelsFamilyBreweryEditor.style.height = `${height}px`;
    }

    updateSwinkelsFamilyBrewery() {
      if (!this.editorReady) { return; }

      const editorDataInput = document.getElementById("product_personalization_editor_data")
      let data
      try {
        data = JSON.parse(editorDataInput.value)
      } catch (e) {
        return
      }

      const records = data.records || []

      const sfbBeers = records.filter(b => b.delivered_by && b.delivered_by !== "")
      const mappedSfbBeers = sfbBeers.map(this.mapSfbBeer)
      this.editor.api.setFormFieldValue('sfbBeer', JSON.stringify(mappedSfbBeers))

      const otherBeers = records.filter(b => !b.delivered_by || b.delivered_by === "")
      const mappedOtherBeers = otherBeers.map(this.mapOtherBeer)
      this.editor.api.setFormFieldValue('otherBeer', JSON.stringify(mappedOtherBeers))

      const lang = (data.language || 'nl').toLowerCase();
      const languageMap = {
        nl: 'dutch',
        fr: 'french',
        de: 'german',
        en: 'english'
      };

      const datasetPrefix = languageMap[lang] || languageMap['nl'];
      const bitternessKey = `${datasetPrefix}Bitterness`;
      const flavourKey = `${datasetPrefix}Flavour`;

      const bitterness = editorDataInput.dataset[bitternessKey] || '';
      const flavour = editorDataInput.dataset[flavourKey] || '';

      Promise.all([
        this.editor.api.setFormFieldValue('language', lang.toUpperCase()),
        this.editor.api.setFormFieldValue('bitterness', bitterness),
        this.editor.api.setFormFieldValue('flavour', flavour)
      ]).then(() => {
        this.editor.api.clearSelection();
      });
    }

    mapSfbBeer(beer) {
      return {
        packshot: beer[`${beer.variant}_visual_url`],
        alcohol: beer.alcohol_by_volume,
        bitterness: beer.bitterness,

        price: beer.price1,
        volume: beer.volume1,
        unit: beer.unit1,
        price_2: beer.price2,
        volume_2: beer.volume2,
        unit_2: beer.unit2,
        price_3: beer.price3,
        volume_3: beer.volume3,
        unit_3: beer.unit3,

        hero: beer.hero,

        NL_productname: beer.name,
        NL_description: beer.dutch_frame_description_400_characters,
        NL_category: beer.dutch_flavour_category,
        NL_variant: beer.dutch_variant,
        NL_taste: beer.dutch_flavour_description_28_characters,
        NL_beerstyles: beer.dutch_style,

        EN_productname: beer.name,
        EN_description: beer.english_frame_description_400_characters,
        EN_category: beer.english_flavour_category,
        EN_variant: beer.english_variant,
        EN_taste: beer.english_flavour_description_28_characters,
        EN_beerstyles: beer.english_style,

        DE_productname: beer.name,
        DE_description: beer.german_frame_description_400_characters,
        DE_category: beer.german_flavour_category,
        DE_variant: beer.german_variant,
        DE_taste: beer.german_flavour_description_28_characters,
        DE_beerstyles: beer.german_style,

        FR_productname: beer.name,
        FR_description: beer.french_frame_description_400_characters,
        FR_category: beer.french_flavour_category,
        FR_variant: beer.french_variant,
        FR_taste: beer.french_flavour_description_28_characters,
        FR_beerstyles: beer.french_style,
      }
    }

    mapOtherBeer(beer) {
      return {
        productname: beer.name,
        alcohol: beer.alcohol_by_volume,

        price: beer.price1,
        volume: beer.volume1,
        unit: beer.unit1,
        price_2: beer.price2,
        volume_2: beer.volume2,
        unit_2: beer.unit2,
        price_3: beer.price3,
        volume_3: beer.volume3,
        unit_3: beer.unit3,
      }
    }
  };

